import { GetState } from 'zustand';
import { ICountdown } from '../../concepts/countdown';
import { IDocs } from '../../concepts/docs';
import { IGame } from '../../concepts/game';
import { ILocations } from '../../concepts/locations';
import { IToDos } from '../../concepts/to-dos';
import { IPhaseExecutorFn } from '../game';

export const startPhase1: IPhaseExecutorFn = (
  get: GetState<IGame & IDocs & IToDos & ILocations & ICountdown>
) => {
  get().closeLocation('/');
  get().pinLocation('phases/phase-1/intro');
  get().openLocation('phases/phase-1/intro');
  get().openLocation('phases/phase-1/scenario');

  get().collectDoc('AnnoScorso');

  get().clearToDos();
  ToDos.forEach(get().appendToDo);

  get().startCountdown(get().currentPhaseStartTime, 45 * 60 * 1_000);
};

const ToDos = [
  {
    id: 'read-intro',
    type: 'read-info',
    locationToVisit: 'phases/phase-1/intro',
    payload: null,
    nudge: '',
  },
  {
    id: 'read-scenario',
    type: 'read-info',
    locationToVisit: 'phases/phase-1/scenario',
    payload: null,
    nudge: '',
  },
  {
    id: 'read-all-docs',
    type: 'read-all-docs',
    locationToVisit: 'docs',
    payload: null,
    nudge: 'Leggi tutti i documenti prima di proseguire',
  },
];
